import React, { useState, useEffect } from 'react';
import { CSVLink } from 'react-csv';
import { MdDownload } from 'react-icons/md';

import BBITable from '../../helpers/bBITable/BBITable';
import DateOnlyFormatter from '../../helpers/inputs/DateOnlyFormatter';
import Filter from '../../helpers/filter/Filter';
import FilterData from '../../helpers/filter/FilterData';
import Get from '../../api/internal/Get';
import Header from '../../layouts/Header';
import View from '../../helpers/slab/View';
import ViewCashFlow from '../../features/views/cashFlow/CashFlow';
import ViewLoad from '../../features/views/load/Load';
import classesGlobal from '../../assets/Global.module.css';

function CashFlow(toggleBoardRefresh) {
  const [filterValue, setFilterValue] = useState('');
  const [cashFlowBoard, setCashFlowBoard] = useState<Array<CashFlowBoard>>([]);
  // const [isOpen, setIsOpen] = useState(false);

  const csvFileName =
    new Date().toISOString().split('T')[0].replace(/[-]/g, '') +
    '_Cash Flow Report.csv';

  useEffect(() => {
    Get(`/Accounting/GetCashFlowBoard/`).then(response => {
      if (response) {
        setCashFlowBoard(response.data);
      }
    });
  }, [toggleBoardRefresh]);

  const formattedCashFlowBoard = cashFlowBoard.map(cashFlow => ({
    ...cashFlow,
    date: DateOnlyFormatter(cashFlow.date),
    amount: cashFlow.amount.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    }),
  }));

  let columnConfig = [
    {
      key: '1',
      attribute: 'cashFlowId',
      header: 'Cash Flow #',
      onClick: e =>
        View(<ViewCashFlow cashFlowId={e.target.innerText} startPage={null} />),
      dataType: 'number',
    },
    {
      key: '2',
      attribute: 'assignmentType',
      header: 'Assignment Type',
    },
    {
      key: '4',
      attribute: 'assignmentName',
      header: 'Assignment Name',
    },
    {
      key: '5',
      attribute: 'loadId',
      header: 'Load #',
      onClick: e => View(<ViewLoad loadId={e.target.innerText} />),
      dataType: 'number',
    },
    {
      key: '6',
      attribute: 'assetName',
      header: 'Asset Name',
    },
    {
      key: '7',
      attribute: 'note',
      header: 'Note',
    },
    {
      key: '8',
      attribute: 'date',
      header: 'Date',
      dataType: 'date',
    },
    {
      key: '9',
      attribute: 'amount',
      header: 'Amount',
      dataType: 'currency',
    },
  ];

  let tableData = FilterData(formattedCashFlowBoard, filterValue);

  return (
    <>
      <h1>Cash Flow</h1>
      <Header>
        <div>
          <button>
            <CSVLink
              data={cashFlowBoard}
              headers={[
                { label: 'Assignment Number', key: 'assignmentId' },
                { label: 'Assignment Type', key: 'assignmentType' },
                { label: 'Assignment Name', key: 'assignmentName' },
                { label: 'Employee Number', key: 'employeeId' },
                { label: 'Load Number', key: 'loadId' },
                { label: 'Asset Number', key: 'assetId' },
                { label: 'Asset Name', key: 'assetName' },
                { label: 'Note', key: 'note' },
                { label: 'Date', key: 'date' },
                { label: 'Amount', key: 'amount' },
              ]}
              filename={csvFileName}
            >
              <MdDownload />
              <span>Download</span>
            </CSVLink>
          </button>
        </div>
        <div>
          <Filter
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            placeholder="Filter cash flows"
          />
        </div>
      </Header>
      <BBITable data={tableData} columns={columnConfig} />
    </>
  );
}

export default CashFlow;
